<template>
  <div class="order-page">
    <!-- <h1>直通车宝贝</h1> -->
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">

          <el-col :span="6">
            <el-form-item label-width
                          prop="plan_name"
                          label="推广计划名称">
              <el-input v-model="form.plan_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="item_name"
                          label="宝贝名称">
              <el-input v-model="form.item_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="item_type"
                          label="宝贝类型">
              <el-input v-model="form.item_type"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="item_id"
                          label="商品id">
              <el-input v-model="form.item_id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="search_type"
                          label="搜索类型">
              <el-input v-model="form.search_type"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="from"
                          label="流量来源">
              <el-input v-model="form.from"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width
                          prop="create_time"
                          label="日期">
              <!-- <el-input v-model="form.create_time"></el-input> -->
              <el-date-picker v-model="form.create_time"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="searchAreaStatus">
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithImport">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <!-- <el-table-column prop="create_name" align="center" header-align="center" label="日期"></el-table-column> -->
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="日期"
                       width="100px"></el-table-column>
      <el-table-column prop="plan_name"
                       align="center"
                       header-align="center"
                       label="推广计划名称"></el-table-column>
      <el-table-column prop="item_name"
                       align="center"
                       header-align="center"
                       label="宝贝名称"
                       min-width="220px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="item_type"
                       align="center"
                       header-align="center"
                       label="宝贝类型"></el-table-column>
      <el-table-column prop="item_id"
                       align="center"
                       header-align="center"
                       label="商品id"></el-table-column>
      <el-table-column prop="search_type"
                       align="center"
                       header-align="center"
                       label="搜索类型"></el-table-column>
      <el-table-column prop="from"
                       align="center"
                       header-align="center"
                       label="流量来源"></el-table-column>
      <el-table-column prop="zxliang"
                       align="center"
                       header-align="center"
                       label="展现量"></el-table-column>
      <el-table-column prop="djliang"
                       align="center"
                       header-align="center"
                       label="点击量"></el-table-column>
      <el-table-column prop="hf_f"
                       align="center"
                       header-align="center"
                       label="花费(分)"></el-table-column>
      <el-table-column prop="ctr"
                       align="center"
                       header-align="center"
                       label="点击率"></el-table-column>
					   
					   
		<el-table-column prop="pjdjhf_f"
                       align="center"
                       header-align="center"
                       label="平均点击花费(分)"></el-table-column>
					   
					   
		<el-table-column prop="qczxhf_f"
                       align="center"
                       header-align="center"
                       label="千次展现花费(分)"></el-table-column>
					   
					   
		<el-table-column prop="djzhlv"
                       align="center"
                       header-align="center"
                       label="点击转化率"></el-table-column>
					   
					   
		<el-table-column prop="zjcjbs_f"
                       align="center"
                       header-align="center"
                       label="直接成交金额(分)"></el-table-column>
					   


		<el-table-column prop="zjcjbs"
                       align="center"
                       header-align="center"
                       label="直接成交笔数"></el-table-column>
					   
		<el-table-column prop="jjcjbs_f"
                       align="center"
                       header-align="center"
                       label="间接成交金额(分)"></el-table-column>
					   
		<el-table-column prop="jjcjbs"
                       align="center"
                       header-align="center"
                       label="间接成交笔数"></el-table-column>
					   
		<el-table-column prop="zcjje_f"
                       align="center"
                       header-align="center"
                       label="总成交金额(分)"></el-table-column>
					   
					   
					   
		<el-table-column prop="zcjbs"
                       align="center"
                       header-align="center"
                       label="总成交笔数"></el-table-column>
					   
		<el-table-column prop="bbscs"
                       align="center"
                       header-align="center"
                       label="宝贝收藏数"></el-table-column>
					   
		<el-table-column prop="dpscs"
                       align="center"
                       header-align="center"
                       label="店铺收藏数"></el-table-column>
					   
		<el-table-column prop="zscs"
                       align="center"
                       header-align="center"
                       label="总收藏数"></el-table-column>




		<el-table-column prop="roi"
                       align="center"
                       header-align="center"
                       label="投入产出比"></el-table-column>
					   
		<el-table-column prop="zjgwcs"
                       align="center"
                       header-align="center"
                       label="直接购物车数"></el-table-column>
					   
		<el-table-column prop="jjgwcs"
                       align="center"
                       header-align="center"
                       label="间接购物车数"></el-table-column>
					   
		<el-table-column prop="zgwcs"
                       align="center"
                       header-align="center"
                       label="总购物车数"></el-table-column>							   

		<el-table-column prop="zyscjje"
                       align="center"
                       header-align="center"
                       label="总预售成交金额"></el-table-column>	
					   
					   
					   
	


		<el-table-column prop="zyscjbs"
                       align="center"
                       header-align="center"
                       label="总预售成交笔数"></el-table-column>
					   
		<el-table-column prop="zjyscjje"
                       align="center"
                       header-zyscjbsalign="center"
                       label="直接预售成交金额"></el-table-column>
					   
		<el-table-column prop="zjyscjbs"
                       align="center"
                       header-align="center"
                       label="直接预售成交笔数"></el-table-column>
					   
		<el-table-column prop="jjyscjje"
                       align="center"
                       header-align="center"
                       label="间接预售成交金额"></el-table-column>							   

		<el-table-column prop="jjyscjbs"
                       align="center"
                       header-align="center"
                       label="间接预售成交笔数"></el-table-column>	
   
					  
					   
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import handleExport from '@/common/mixins/handle-export'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin, handleExport],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/promote/direct-goods/index.vue